<template>
    <div>
        <b-tab :title="$tc('message.prescriptions',2)" :active="pathHas($tc('message.prescriptions',2))">
            <b-link class="ml-4" :to="{ name: 'add-prescription' }" variant="primary" v-if="hasAdminRole  || hasPraticienRole || hasMedecinControleRole || hasAssistante">
                <i class="fas fa-plus-circle edit-icon"></i> {{ $tc('message.prescriptions',1) }}
            </b-link>

            <b-card-body>
                <vue-good-table id="prescriptions" :columns="prescriptionsColumns" :rows="prescriptionsRows" :search-options="enabled" :pagination-options="paginationOptions" @on-row-click="onPrescriptionRowClick" />
            </b-card-body>
        </b-tab>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
import moment from "moment";
export default {
    name: "Prescription",
    computed: {
         ...mapGetters(["file"]),

        mMedicalFile: function () {
            return _.isUndefined(this.file) ? [] : this.file;
        },
        prescriptionsRows: function () {
            return this.mMedicalFile.ordonances;
        },
        traitementsRows: function () {
            let tArray = [];

            _.forEach(this.mTraitements, function (traitement) {
                // tArray.push({date:traitement.created_at,description: traitement.description,slug:traitement.slug})
                tArray.push({
                    description: traitement.description,
                    slug: traitement.slug
                })
            });

            return tArray;
        },
    },
    props: ['hasAdminRole', 'hasMedecinControleRole', 'hasAssistante', 'hasPraticienRole', 'file_id'],
    data() {
        return {
            prescriptionsColumns: [{
                label: this.$i18n.t('message.prescriptionDate'),
                field: 'date_prescription',
                type: 'date',
                dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
                dateOutputFormat: 'dd/MM/yyyy',
            }, ],
            paginationOptions: {
                enabled: true,
                mode: 'records',
                perPageDropdown: [3, 6, 10]
            },

            enabled: {
                enabled: true
            },

            sort: {
                enabled: true,
                initialSortBy: {
                    field: 'date',
                    type: 'desc'
                }
            },
            
        }
    },
    validations() {
        return {
            form: {
                responsable:{},
            }
        }
	},
    methods: {
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },
        errorshasField(field) {
            return this.errors ? this.errors.hasOwnProperty(field) : false;
        },  
        onPrescriptionRowClick(params) {
            this.$router.push({
                name: 'prescription',
                params: {
                    prescription: params.row.slug
                }
            });
        },
        pathHas(element) {
        let result = (this.$route.fullPath).includes(element);
            if (result) {
                if ($('#' + element).length) {
                    document.getElementById(element).scrollIntoView(top);
                }
            }

            return result;
        },
        notEmpty(item) {
            return item.length > 0;
        },
    },
    mounted() {
        
    }
}
</script>
<style lang="">
    
</style>